(function () {
  "use strict";

  var BUSY = false;
  var WRAP_CLASS = "ccc-pop-wrap";
  var bound = false;
  var MODE = "popup";
  var CLOSE_MS = 340;
  var SCROLL_Y = 0;
  var NO_MOTION = false;
  try { NO_MOTION = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  if (NO_MOTION) CLOSE_MS = 0;

  var DRAWER_ON = (function () {
    try {
      if (/[?&]ccc_drawer=1/.test(location.search)) sessionStorage.setItem("ccc_drawer", "1");
      if (/[?&]ccc_drawer=0/.test(location.search)) sessionStorage.removeItem("ccc_drawer");
      if (sessionStorage.getItem("ccc_drawer") === "1") return true;
    } catch (e) {  }
    return window.CCC_DRAWER_ON === true;
  })();

  function isDesktop() {
    try { return !!(window.matchMedia && window.matchMedia("(min-width: 768px)").matches); }
    catch (e) { return false; }
  }

  var LAST_FOCUS = null;

  function lockPage() {
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    if (sbw > 0) document.documentElement.style.setProperty("--ccc-sbw", sbw + "px");
    document.documentElement.classList.add("ccc-lock");
  }
  function unlockPage() {
    document.documentElement.classList.remove("ccc-lock");
    document.documentElement.style.removeProperty("--ccc-sbw");
    unlockPhone();
  }
  var PHONE_BLOCK = null;
  var DRAWER_SCROLLERS = ".ccc-pop-items, .cart__popup, .ccc-pop-scroll";
  function lockPhone() {
    if (PHONE_BLOCK) return;
    document.body.style.setProperty("overflow", "visible", "important");
    PHONE_BLOCK = function (e) {
      var t = e.target;
      if (t && t.closest && t.closest(DRAWER_SCROLLERS)) return;
      if (e.cancelable) e.preventDefault();
    };
    document.addEventListener("touchmove", PHONE_BLOCK, { passive: false });
    document.addEventListener("wheel", PHONE_BLOCK, { passive: false });
  }
  function releasePhoneOverflow() {
    document.body.style.removeProperty("overflow");
  }
  function unlockPhone() {
    if (!PHONE_BLOCK) return false;
    document.removeEventListener("touchmove", PHONE_BLOCK, { passive: false });
    document.removeEventListener("wheel", PHONE_BLOCK, { passive: false });
    PHONE_BLOCK = null;
    return true;
  }

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return (ctx || document).querySelectorAll(sel); }

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", "\"": "&quot;" }[c];
    });
  }

  function postJSON(url, data) {
    return fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify(data)
    }).then(function (r) { return r.json(); });
  }

  function buildFrame() {
    var wrap = qs("." + WRAP_CLASS);
    if (wrap) return qs("#content_cart__popup_nt", wrap);

    wrap = document.createElement("div");
    wrap.className = "nov-wrap " + WRAP_CLASS;
    wrap.style.position = "fixed";
    wrap.style.top = "0";
    wrap.style.left = "0";
    wrap.style.right = "0";
    wrap.style.bottom = "0";
    wrap.style.zIndex = "99999";
    wrap.style.background = "rgba(13,27,42,.55)";
    wrap.style.display = "none";
    wrap.style.alignItems = "flex-start";
    wrap.style.justifyContent = "center";
    wrap.innerHTML =
      '<div class="nov-container nov-inline-holder">' +
        '<div class="nov-content">' +
          '<div class="cart__popup cart__popup_upsell">' +
          '<a class="' + WRAP_CLASS + '-close" href="javascript:void(0);" aria-label="Close">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">' +
              '<path d="M6 6l12 12M18 6L6 18"/>' +
            '</svg>' +
          '</a>' +
            '<div id="content_cart__popup_nt"></div>' +
          '</div>' +
        '</div>' +
      '</div>';
    wrap.classList.add(WRAP_CLASS + "--anim");
    document.body.appendChild(wrap);

    qs("." + WRAP_CLASS + "-close", wrap).addEventListener("click", closePopup);
    wrap.addEventListener("click", function (e) {
      var cl = e.target && e.target.classList;
      if (e.target === wrap || (cl && (cl.contains("nov-container") || cl.contains("nov-content")))) {
        closePopup();
      }
    });

    var root = qs("#content_cart__popup_nt", wrap);
    root.addEventListener("click", onPopupClick);
    root.addEventListener("change", onPopupChange);
    return root;
  }

  function showFrame() {
    var wrap = qs("." + WRAP_CLASS);
    if (!wrap) return;
    var drawer = MODE === "drawer";
    wrap.classList.toggle(WRAP_CLASS + "--drawer", drawer);
    var firstOpen = !document.body.classList.contains("cart_popup_opened");
    if (firstOpen) {
      SCROLL_Y = window.scrollY || window.pageYOffset || 0;
    }
    document.body.classList.add("cart_popup_opened");
    document.body.classList.toggle("ccc-drawer-open", drawer);

    if (firstOpen) {
      if (isDesktop()) lockPage();
      else lockPhone();
      SCROLL_Y = 0;
    }

    var wasOpen = wrap.style.display === "flex";
    wrap.style.setProperty("display", "flex", "important");
    if (wasOpen) {
      wrap.classList.add(WRAP_CLASS + "--in");
      histPush();
      return;
    }
    void wrap.offsetWidth;
    var started = false;
    function startSlide() {
      if (started) return;
      started = true;
      wrap.classList.add(WRAP_CLASS + "--in");
      histPush();
      focusIntoPanel();
    }
    requestAnimationFrame(function () { requestAnimationFrame(startSlide); });
    window.setTimeout(startSlide, 60);
  }

  function panelEl() {
    var wrap = qs("." + WRAP_CLASS);
    return wrap ? qs(".cart__popup.cart__popup_upsell", wrap) : null;
  }

  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),' +
                  'textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function focusIntoPanel() {
    var panel = panelEl();
    if (!panel) return;
    panel.setAttribute("role", "dialog");
    panel.setAttribute("aria-modal", "true");
    panel.setAttribute("aria-label", MODE === "drawer" ? "Your cart" : "Added to cart");
    panel.setAttribute("tabindex", "-1");
    if (!LAST_FOCUS && document.activeElement && document.activeElement !== document.body) {
      LAST_FOCUS = document.activeElement;
    }
    try { panel.focus({ preventScroll: true }); } catch (e) { try { panel.focus(); } catch (e2) {} }
  }

  function restoreFocus() {
    var el = LAST_FOCUS;
    LAST_FOCUS = null;
    if (!el || !el.isConnected || typeof el.focus !== "function") return;
    try { el.focus({ preventScroll: true }); } catch (e) { try { el.focus(); } catch (e2) {} }
  }

  function trapTab(e) {
    if (e.key !== "Tab" && e.keyCode !== 9) return;
    if (!isOpen()) return;
    var panel = panelEl();
    if (!panel) return;
    var items = Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
    if (!items.length) { e.preventDefault(); try { panel.focus(); } catch (err) {} return; }
    var first = items[0], last = items[items.length - 1];
    if (!panel.contains(document.activeElement)) {
      e.preventDefault();
      (e.shiftKey ? last : first).focus();
      return;
    }
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  }

  function restoreScroll() {
    var y = SCROLL_Y;
    SCROLL_Y = 0;
    releaseScrollRestoration();
    releasePhoneOverflow();
    if (y <= 0) return;
    window.scrollTo(0, y);
    requestAnimationFrame(function () { window.scrollTo(0, y); });
  }

  function closePopup() {
    var wrap = qs("." + WRAP_CLASS);
    MODE = "popup";
    window.clearTimeout(bandTimer);
    BAND = null;
    histDrop();
    if (!wrap) {
      document.body.classList.remove("cart_popup_opened");
      document.body.classList.remove("ccc-drawer-open");
      unlockPage();
      restoreScroll();
      restoreFocus();
      return;
    }
    wrap.classList.remove(WRAP_CLASS + "--in");
    unlockPage();
    restoreFocus();
    window.setTimeout(function () {
      if (!wrap.classList.contains(WRAP_CLASS + "--in")) {
        wrap.style.setProperty("display", "none", "important");
        document.body.classList.remove("cart_popup_opened");
        document.body.classList.remove("ccc-drawer-open");
        restoreScroll();
      }
    }, CLOSE_MS);
  }

  function isOpen() {
    var wrap = qs("." + WRAP_CLASS);
    return !!(wrap && wrap.classList.contains(WRAP_CLASS + "--in"));
  }

  var HIST_MARK = "ccc-drawer";
  var histPushed = false;

  var scrollRestoreWas = null;
  function releaseScrollRestoration() {
    if (scrollRestoreWas === null) return;
    try { history.scrollRestoration = scrollRestoreWas; } catch (e) {}
    scrollRestoreWas = null;
  }
  window.addEventListener("pagehide", releaseScrollRestoration);

  function histPush() {
    if (histPushed) return;
    try {
      if ("scrollRestoration" in history && scrollRestoreWas === null) {
        scrollRestoreWas = history.scrollRestoration;
        history.scrollRestoration = "manual";
      }
      history.pushState({ ccc: HIST_MARK }, ""); histPushed = true;
    } catch (e) {}
  }
  function histDrop() {
    if (!histPushed) return;
    histPushed = false;
    try { history.back(); } catch (e) {}
  }
  window.addEventListener("popstate", function () {
    if (!histPushed) return;
    histPushed = false;
    if (isOpen()) closePopup();
  });

  var BAND_MS = 4000;
  var OPEN_MS = 220;
  var EXIT_MS = 145;
  var LEAD_MS = 120;
  var CALM_MS = 150;
  var EASE    = "cubic-bezier(.23,1,.32,1)";
  var GONE    = "translateX(34px)";
  var BAND = null;
  var bandTimer = null;

  var BOX = ["height", "margin-top", "margin-bottom", "padding-top", "padding-bottom",
             "border-top-width", "border-bottom-width"];
  function setImp(el, p, v) { el.style.setProperty(p, v, "important"); }
  function grabBox(el) {
    var cs = window.getComputedStyle(el);
    var b = { "height": el.getBoundingClientRect().height + "px" };
    for (var i = 1; i < BOX.length; i++) b[BOX[i]] = cs.getPropertyValue(BOX[i]);
    return b;
  }
  function applyBox(el, b) { for (var k in b) setImp(el, k, b[k]); }
  function zeroBox(el) { for (var i = 0; i < BOX.length; i++) setImp(el, BOX[i], "0px"); }
  function boxTr(ms, delay) {
    var d = " " + (delay || 0) + "ms", out = [];
    for (var i = 0; i < BOX.length; i++) out.push(BOX[i] + " " + ms + "ms " + EASE + d);
    return out.join(",");
  }
  function naturalHeight(el) {
    var h = el.style.getPropertyValue("height"), pr = el.style.getPropertyPriority("height");
    var t = el.style.getPropertyValue("transition");
    el.style.setProperty("transition", "none");
    setImp(el, "height", "auto");
    var px = el.getBoundingClientRect().height;
    if (h) el.style.setProperty("height", h, pr); else el.style.removeProperty("height");
    if (t) el.style.setProperty("transition", t); else el.style.removeProperty("transition");
    void el.offsetWidth;
    return px;
  }
  function settle(el) { setImp(el, "height", "auto"); el.style.removeProperty("transition"); }
  function bandNode(root) { return qs(".ccc-pop-msg", root || document); }

  function calmIn(el) {
    el.style.setProperty("opacity", "0");
    void el.offsetWidth;
    el.style.setProperty("transition", "opacity " + CALM_MS + "ms ease");
    el.style.setProperty("opacity", "1");
    window.setTimeout(function () {
      if (el.parentNode) { el.style.removeProperty("transition"); el.style.removeProperty("opacity"); }
    }, CALM_MS + 20);
  }
  function calmOut(el, done) {
    el.style.setProperty("transition", "opacity " + CALM_MS + "ms ease");
    el.style.setProperty("opacity", "0");
    window.setTimeout(function () {
      if (el.parentNode) el.parentNode.removeChild(el);
      if (done) done();
    }, CALM_MS + 20);
  }

  function bandHTML(reason, name) {
    var removed = reason === "removed";
    return '<i class="fa ' + (removed ? "fa-trash-o" : "fa-check") + '" aria-hidden="true" ' +
           'style="margin-right:4px"></i>' +
           '<strong style="color:' + (removed ? "#501313" : "#173404") + '">' +
           esc(name || "Item") + '</strong> ' +
           (removed ? "removed from cart" : "added to your cart");
  }
  function bandSet(html, cls) {
    BAND = { html: html, cls: cls, dieAt: Date.now() + BAND_MS, fresh: true };
  }
  function buildBand(html, cls, announce) {
    var removed = cls === "removed";
    var d = document.createElement("div");
    d.className = "ccc-pop-msg" + (removed ? " removed" : "");
    if (announce) d.setAttribute("role", "status");
    d.setAttribute("style",
      "display:block;width:100%;box-sizing:border-box;margin:8px 0 8px;padding:9px 12px;" +
      "border-radius:6px;font-size:12px;line-height:1.4;font-family:'Bai Jamjuree',sans-serif;" +
      "overflow:hidden;cursor:pointer;" +
      "background:" + (removed ? "#FCEBEB" : "#EAF3DE") + ";" +
      "color:" + (removed ? "#791F1F" : "#27500A") + ";");
    d.innerHTML = html;
    return d;
  }

  function bandInto(root) {
    if (!BAND) return;
    var body = qs(".ccc-pop-body", root), items = qs(".ccc-pop-items", root);
    if (!body || !items) return;
    body.insertBefore(buildBand(BAND.html, BAND.cls, BAND.fresh), items);
    BAND.fresh = false;
  }

  function bandLive(html, cls) {
    bandSet(html, cls);
    var body = qs(".ccc-pop-body"), items = qs(".ccc-pop-items");
    if (!body || !items) return;
    var el = bandNode();
    if (NO_MOTION) {
      if (el && el.parentNode) el.parentNode.removeChild(el);
      var calm = buildBand(html, cls, true);
      body.insertBefore(calm, items);
      calmIn(calm);
      BAND.fresh = false;
      return;
    }
    if (el) {
      var removed = cls === "removed";
      var from = el.getBoundingClientRect().height;
      el.className = "ccc-pop-msg" + (removed ? " removed" : "");
      el.innerHTML = html;
      el.style.setProperty("background", removed ? "#FCEBEB" : "#EAF3DE");
      el.style.setProperty("color", removed ? "#791F1F" : "#27500A");
      var to = naturalHeight(el);
      setImp(el, "height", from + "px");
      void el.offsetWidth;
      el.style.setProperty("transition", "height " + OPEN_MS + "ms " + EASE + " " + LEAD_MS + "ms," +
                                         "background-color 200ms ease,color 200ms ease");
      setImp(el, "height", to + "px");
      window.setTimeout(function () { if (el.parentNode) settle(el); }, LEAD_MS + OPEN_MS + 40);
      BAND.fresh = false;
      return;
    }
    el = buildBand(html, cls, true);
    body.insertBefore(el, items);
    var box = grabBox(el);
    zeroBox(el);
    el.style.setProperty("opacity", "0");
    el.style.setProperty("transform", GONE);
    void el.offsetWidth;
    el.style.setProperty("transition", boxTr(OPEN_MS, LEAD_MS) +
      ",opacity " + OPEN_MS + "ms " + EASE + " " + LEAD_MS + "ms" +
      ",transform " + OPEN_MS + "ms " + EASE + " " + LEAD_MS + "ms");
    applyBox(el, box);
    el.style.setProperty("opacity", "1");
    el.style.setProperty("transform", "none");
    window.setTimeout(function () { if (el.parentNode) settle(el); }, LEAD_MS + OPEN_MS + 40);
    BAND.fresh = false;
  }

  function armBand(el) {
    window.clearTimeout(bandTimer);
    if (!BAND || !el) return;
    bandTimer = window.setTimeout(closeBand, Math.max(0, BAND.dieAt - Date.now()));
    if (el.getAttribute("data-armed")) return;
    el.setAttribute("data-armed", "1");
    el.addEventListener("mouseenter", function () { window.clearTimeout(bandTimer); });
    el.addEventListener("mouseleave", function () {
      window.clearTimeout(bandTimer);
      if (!BAND) return;
      BAND.dieAt = Date.now() + 1200;
      bandTimer = window.setTimeout(closeBand, 1200);
    });
    el.addEventListener("click", function () { window.clearTimeout(bandTimer); closeBand(); });
  }

  function closeBand() {
    window.clearTimeout(bandTimer);
    BAND = null;
    var el = bandNode();
    if (!el || !el.parentNode) return;
    if (NO_MOTION) { calmOut(el); return; }
    applyBox(el, grabBox(el));
    void el.offsetWidth;
    el.style.setProperty("transition",
      "opacity 200ms ease,transform " + EXIT_MS + "ms " + EASE + "," + boxTr(EXIT_MS, LEAD_MS));
    el.style.setProperty("opacity", "0");
    el.style.setProperty("transform", GONE);
    zeroBox(el);
    window.setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); },
                      LEAD_MS + EXIT_MS + 40);
  }

  function leaveRow(row) {
    if (!row) return null;
    if (NO_MOTION) {
      row.style.setProperty("pointer-events", "none");
      row.style.setProperty("transition", "opacity " + CALM_MS + "ms ease");
      row.style.setProperty("opacity", "0");
      return new Promise(function (done) { window.setTimeout(done, CALM_MS + 20); });
    }
    applyBox(row, grabBox(row));
    setImp(row, "overflow", "hidden");
    row.style.setProperty("pointer-events", "none");
    void row.offsetWidth;
    row.style.setProperty("transition",
      "opacity 200ms " + EASE + ",transform " + OPEN_MS + "ms " + EASE + "," + boxTr(OPEN_MS, LEAD_MS));
    row.style.setProperty("opacity", "0");
    setImp(row, "transform", GONE);
    zeroBox(row);
    return new Promise(function (done) {
      window.setTimeout(done, LEAD_MS + OPEN_MS + 40);
    });
  }

  function tuneExpressRow(doc) {
    var x = doc.querySelector(".ccc-pop-pay-x");
    if (!x) return;
    var row = doc.querySelector(".ccc-pop-pay");
    var ace = x.querySelector("shopify-accelerated-checkout-cart");
    var keep = null;
    if (ace && isDesktop()) {
      try {
        var cfg = JSON.parse(ace.getAttribute("wallet-configs") || "[]");
        keep = cfg.filter(function (w) { return w && w.name === "shop_pay"; });
      } catch (e) { keep = null; }
    }
    if (!keep || !keep.length) { x.parentNode.removeChild(x); return; }
    ace.setAttribute("wallet-configs", JSON.stringify(keep));
    if (row) row.className += " is-split";
  }

  function renderPopup(reason, name) {
    return fetch("/cart?view=upsell", { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        tuneExpressRow(doc);
        var root = buildFrame();
        root.innerHTML = "";

        var kids = Array.prototype.slice.call(doc.body.children);
        for (var i = 0; i < kids.length; i++) root.appendChild(kids[i]);

        if (reason === "added") bandSet(bandHTML("added", name), "");
        bandInto(root);

        var totalData = qs("#cccCartTotalData", root);
        var totalCents = totalData ? (parseInt(totalData.getAttribute("data-fsc-cart-total") || "0", 10) || 0) : 0;
        if (totalData && totalData.hasAttribute("data-pickup-lines")) {
          PICKUP_LINES = parseInt(totalData.getAttribute("data-pickup-lines"), 10) || 0;
          applyPickupShelf();
        }

        var wrapEl = qs("." + WRAP_CLASS);
        if (wrapEl) wrapEl.classList.toggle(WRAP_CLASS + "--empty", qsa(".ccc-ci", root).length === 0);

        var addons = qs(".ccc-addons", root);
        if (addons) {
          try {
            document.dispatchEvent(new CustomEvent("ccc:cart-addons", { detail: {
              rule: addons.getAttribute("data-addon-rule"),
              count: parseInt(addons.getAttribute("data-addon-count"), 10) || 0
            } }));
          } catch (e) {}
        }

        showFrame();
        armBand(bandNode());
        return totalCents;
      });
  }

  function refreshProductWidget(totalCents) {
    var nodes = qsa(".rp-fsc");
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].setAttribute("data-fsc-cart-total", totalCents);
      if (window.CCC_FSC && window.CCC_FSC.updateProgress) window.CCC_FSC.updateProgress(nodes[i]);
    }
    applyPickupShelf();
  }

  var PICKUP_LINES = null;
  function pickupLines() {
    if (PICKUP_LINES === null) {
      var shelf = qs(".rp-toolshelf[data-pickup-lines]");
      PICKUP_LINES = shelf ? (parseInt(shelf.getAttribute("data-pickup-lines"), 10) || 0) : 0;
    }
    return PICKUP_LINES;
  }
  function applyPickupShelf() {
    var shelves = qsa(".rp-toolshelf");
    if (!shelves.length) return;
    var hide = pickupLines() > 0;
    for (var i = 0; i < shelves.length; i++) {
      if (shelves[i].hidden !== hide) shelves[i].hidden = hide;
    }
  }

  function onPageRestored(e) {
    if (!e || !e.persisted || !qs(".rp-toolshelf")) return;
    fetch("/cart?view=upsell", { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var d = new DOMParser().parseFromString(html, "text/html").querySelector("#cccCartTotalData");
        if (!d) return;
        PICKUP_LINES = parseInt(d.getAttribute("data-pickup-lines"), 10) || 0;
        refreshProductWidget(parseInt(d.getAttribute("data-fsc-cart-total") || "0", 10) || 0);
      })
      .catch(function () {});
  }
  window.addEventListener("pageshow", onPageRestored);

  function updateCartCount(count) {
    var nodes = document.querySelectorAll(".cart-count, .site-header__cart-count, #CartCount");
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = count;
      if (nodes[i].hasAttribute("data-hide-when-zero")) nodes[i].hidden = !count;
    }
  }


  function onShownAgain(e) {
    if (e.type === "pageshow" && !e.persisted) return;
    if (e.type === "visibilitychange" && document.visibilityState !== "visible") return;
    resyncFromServer().catch(function () {});
  }
  window.addEventListener("pageshow", onShownAgain);
  document.addEventListener("visibilitychange", onShownAgain);

  function drawerLines() {
    var wrap = qs("." + WRAP_CLASS);
    if (!wrap) return "";
    var ins = qsa(".cart__popup-qty--input", wrap), out = [];
    for (var i = 0; i < ins.length; i++) out.push(String(ins[i].id).replace(/^updates_/, "") + ":" + ins[i].value);
    return out.join("|");
  }
  function serverLines(cart) {
    var items = (cart && cart.items) || [], out = [];
    for (var i = 0; i < items.length; i++) out.push(items[i].key + ":" + items[i].quantity);
    return out.join("|");
  }
  function resyncFromServer() {
    return readCart().then(function (cart) {
      updateCartCount(cart.item_count);
      refreshProductWidget(cart.total_price);
      syncCartPage(cart);
      if (isOpen() && !BUSY && drawerLines() !== serverLines(cart)) {
        renderPopup("change").then(refreshProductWidget).catch(function () {});
      }
      return cart;
    });
  }

  var RESYNC_AFTER_ADD_MS = [1500, 5000];
  function resyncAfterAdd(attempt) {
    var i = attempt || 0;
    if (i >= RESYNC_AFTER_ADD_MS.length) return;
    window.setTimeout(function () {
      resyncFromServer().catch(function () { resyncAfterAdd(i + 1); });
    }, RESYNC_AFTER_ADD_MS[i]);
  }

  function readCart() {
    return fetch("/cart.js", { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then(function (r) { return r.json(); });
  }

  function variantQty(cart, ids) {
    var n = 0, items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (ids.indexOf(String(items[i].variant_id)) !== -1) n += items[i].quantity || 0;
    }
    return n;
  }

  function cartAdd(ids, init) {
    var list = [].concat(ids).map(String);
    var before = null;
    return readCart()
      .then(function (c) { before = variantQty(c, list); }, function () {  })
      .then(function () { return fetch("/cart/add.js", init); })
      .then(function (r) {
        return r.json()
          .catch(function () { return {}; })
          .then(function (body) { return { ok: r.ok, body: body }; });
      }, function () { return { ok: false, body: {}, lost: true }; })
      .then(function (res) {
        return readCart().then(function (cart) {
          res.cart = cart;
          res.added = res.ok || (before !== null && variantQty(cart, list) > before);
          return res;
        }, function (err) {
          if (!res.ok) throw err;
          res.cart = null;
          res.added = true;
          res.unread = true;
          return res;
        });
      });
  }

  var CHECK_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';

  var ADDED_MS = 1260;

  function addButtons(form) {
    var list = [];
    var main = qs(".product-form__cart-submit", form);
    if (main) list.push(main);
    var fid = form && form.getAttribute && form.getAttribute("id");
    if (fid) {
      var ext = document.querySelectorAll('button[form="' + fid + '"][name="add"]');
      for (var i = 0; i < ext.length; i++) if (list.indexOf(ext[i]) === -1) list.push(ext[i]);
    }
    return list;
  }

  function flashAdded(form) {
    var btns = addButtons(form);
    for (var i = 0; i < btns.length; i++) flashOne(btns[i]);
  }

  function flashOne(btn) {
    if (window.getComputedStyle(btn).position === "static") btn.style.position = "relative";
    var lbl = qs(".ccc-added-lbl", btn);
    if (!lbl) {
      lbl = document.createElement("span");
      lbl.className = "ccc-added-lbl";
      lbl.setAttribute("role", "status");
      lbl.innerHTML = CHECK_SVG + "<span>Added</span>";
      btn.appendChild(lbl);
      void lbl.offsetWidth;
    }
    if (btn.cccAddedTimer) clearTimeout(btn.cccAddedTimer);
    btn.classList.add("ccc-added");
    btn.cccAddedTimer = setTimeout(function () {
      btn.cccAddedTimer = null;
      var hand = btn.cccAddedHand;
      btn.cccAddedHand = null;
      btn.classList.remove("ccc-added");
      if (hand) hand();
    }, ADDED_MS);
  }

  var bumpTimer = null;
  function bumpCart() {
    var nodes = document.querySelectorAll(".site-header__cart");
    if (!nodes.length) return;
    clearTimeout(bumpTimer);
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].classList.remove("ccc-cart-bump");
      void nodes[i].offsetWidth;
      nodes[i].classList.add("ccc-cart-bump");
    }
    bumpTimer = setTimeout(function () {
      for (var j = 0; j < nodes.length; j++) nodes[j].classList.remove("ccc-cart-bump");
    }, 520);
  }

  function resetQty(form) {
    var q = document.getElementById("RegularQty") || document.getElementById("FreightQty");
    if (!q) return;
    if (form && form.contains && !form.contains(q)) return;
    if (typeof window.CCC_SET_QTY === "function") window.CCC_SET_QTY(1);
    else q.value = 1;
  }

  function setBtnLoading(form, on) {
    var btns = addButtons(form);
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      if (on) {
        btn.setAttribute("aria-busy", "true");
        btn.style.opacity = "0.7";
        btn.style.pointerEvents = "none";
      } else {
        btn.removeAttribute("aria-busy");
        btn.style.opacity = "";
        btn.style.pointerEvents = "";
      }
    }
  }

  function showAddError(form, text, kind) {
    var holder = qs(".ccc-add-error", form);
    if (!holder) {
      holder = document.createElement("div");
      holder.className = "ccc-add-error";
      var btn = qs(".product-form__cart-submit", form);
      if (btn && btn.parentNode) btn.parentNode.appendChild(holder);
      else form.appendChild(holder);
    }
    holder.className = "ccc-add-error ccc-add-error--" + (kind === "notice" ? "notice" : "error");
    holder.style.cssText = kind === "notice"
      ? "color:var(--warn-ink,#854F0B);font-size:13px;font-weight:600;margin-top:8px;"
      : "color:var(--danger,#dc2626);font-size:13px;font-weight:600;margin-top:8px;";
    holder.textContent = text || "This item could not be added.";
    stickyMsg(form, text, kind);
  }

  function stickyMsg(form, text, kind) {
    var bar = null, firstBar = null;
    var btns = addButtons(form);
    var BAR_SEL = ".rp-stickybuy, .rp-deskbar, .fp-stickybuy, .fp-deskbar";
    for (var i = 0; i < btns.length; i++) {
      var cand = btns[i].closest ? btns[i].closest(BAR_SEL) : null;
      if (!cand) continue;
      if (!firstBar) firstBar = cand;
      if (cand.getClientRects().length) { bar = cand; break; }
    }
    if (!bar) bar = firstBar;
    if (!bar) return;
    var msg = qs(".rp-stickybuy-msg", bar);
    if (!msg) {
      msg = document.createElement("div");
      msg.className = "rp-stickybuy-msg";
      msg.setAttribute("role", "status");
      bar.appendChild(msg);
    }
    if (!text) { msg.classList.remove("is-on"); msg.textContent = ""; return; }
    msg.classList.toggle("is-error", kind !== "notice");
    msg.textContent = text;
    void msg.offsetWidth;
    msg.classList.add("is-on");
    if (msg.cccMsgTimer) clearTimeout(msg.cccMsgTimer);
    msg.cccMsgTimer = setTimeout(function () {
      msg.classList.remove("is-on");
      msg.cccMsgTimer = null;
    }, kind === "notice" ? 6000 : 8000);
  }

  function doAdd(form) {
    if (BUSY) return;
    BUSY = true;
    var prev = qs(".ccc-add-error", form);
    if (prev) prev.textContent = "";
    stickyMsg(form, "");
    setBtnLoading(form, true);

    var data = new FormData(form);
    cartAdd(data.getAll("id"), {
      method: "POST",
      headers: { "X-Requested-With": "XMLHttpRequest", "Accept": "application/json" },
      body: data
    })
      .then(function (res) {
        var cart = res.cart;
        var msg = res.body && (res.body.description || res.body.message);
        if (res.lost && !res.added) throw res;

        if (!res.added) {
          updateCartCount(cart.item_count);
          setBtnLoading(form, false);
          showAddError(form, msg || "This item could not be added.", "error");
          return;
        }

        resetQty(form);
        if (form.querySelector("[data-pickup-only]")) PICKUP_LINES = pickupLines() + 1;
        if (cart) {
          refreshProductWidget(cart.total_price);
          updateCartCount(cart.item_count);
        } else {
          resyncAfterAdd(0);
        }
        bumpCart();
        setBtnLoading(form, false);
        flashAdded(form);
        if (!res.ok && msg) {
          showAddError(form, msg, "notice");
          return;
        }
        return openDrawerAfterAdd(res.body);
      })
      .catch(function (e) {
        var human = (e && e.description) ||
          "That didn't go through \u2014 try again. If it keeps failing, call (224) 806-3123.";
        showAddError(form, human, "error");
      })
      .then(function () {
        BUSY = false;
        setBtnLoading(form, false);
      });
  }

  function openDrawerAfterAdd(body) {
    if (!DRAWER_ON) return;
    if (!isDesktop()) return;
    var item = body && body.items && body.items[0] ? body.items[0] : body;
    var name = item && (item.product_title || item.title) || null;
    MODE = "drawer";
    return renderPopup("added", name).catch(function () { MODE = "popup"; });
  }

  function doChange(line, qty, reason, name, row) {
    if (BUSY) return;
    BUSY = true;
    var leaving = null;
    if (reason === "removed" && row) {
      bandLive(bandHTML("removed", name), "removed");
      leaving = leaveRow(row);
    }
    Promise.all([postJSON("/cart/change.js", { line: line, quantity: qty }), leaving])
      .then(function (res) {
        var cart = res[0];
        if (cart && typeof cart.item_count === "number") updateCartCount(cart.item_count);
        return renderPopup(reason, name);
      })
      .then(function (totalCents) {
        refreshProductWidget(totalCents);
        syncCartPage();
      })
      .catch(function () {})
      .then(function () { BUSY = false; });
  }

  function doAddonAdd(btn) {
    if (BUSY) return;
    var vid = btn.getAttribute("data-vid");
    if (!vid) return;
    BUSY = true;
    var was = btn.textContent;
    btn.disabled = true;
    btn.textContent = "Adding\u2026";
    function give_up(msg) {
      btn.disabled = false;
      btn.textContent = was;
      var row = btn.closest(".ccc-addon-row");
      var why = row && qs(".ccc-addon-err", row);
      if (why) why.textContent = msg;
    }
    cartAdd(vid, {
      method: "POST",
      headers: { "Content-Type": "application/json;charset=utf-8", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify({ id: vid, quantity: 1 })
    })
      .then(function (res) {
        var cart = res.cart;
        if (cart && typeof cart.item_count === "number") updateCartCount(cart.item_count);
        if (!res.added) { give_up("Could not add it. Try again."); return null; }
        if (!cart) resyncAfterAdd(0);
        return renderPopup("change").then(function (totalCents) {
          refreshProductWidget(totalCents);
          syncCartPage();
        }, function () {
          btn.textContent = "Added";
          if (cart) resyncAfterAdd(0);
        });
      })
      .catch(function () { give_up("Could not add it. Try again."); })
      .then(function () { BUSY = false; });
  }

  function onPopupClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest(".ccc-btn--outline")) {
      e.preventDefault();
      e.stopPropagation();
      closePopup();
      return;
    }

    var addon = t.closest("[data-addon-add]");
    if (addon) {
      e.preventDefault();
      e.stopPropagation();
      doAddonAdd(addon);
      return;
    }

    var minus = t.closest(".cart__popup-qty--minus");
    var plus = t.closest(".cart__popup-qty--plus");
    var remA = t.closest(".cart__popup-remove a");

    if (minus || plus) {
      e.preventDefault();
      e.stopPropagation();
      var qwrap = (minus || plus).closest(".ccc-ci-qty");
      var input = qwrap && qs(".cart__popup-qty--input", qwrap);
      if (!input) return;
      var line = parseInt(input.getAttribute("data-line"), 10);
      var cur = parseInt(input.value, 10) || 1;
      var next = plus ? cur + 1 : cur - 1;
      if (next < 1) next = 1;
      if (next === cur) return;
      doChange(line, next, "change");
      return;
    }

    if (remA) {
      e.preventDefault();
      e.stopPropagation();
      var ci = remA.closest(".ccc-ci");
      var titleEl = ci && qs(".ccc-ci-title", ci);
      var name = titleEl ? titleEl.textContent.trim() : "";
      var href = remA.getAttribute("href") || "";
      var m = href.match(/line=(\d+)/);
      var line2 = m ? parseInt(m[1], 10) : NaN;
      if (isNaN(line2)) {
        var inp = ci && qs(".cart__popup-qty--input", ci);
        line2 = inp ? parseInt(inp.getAttribute("data-line"), 10) : NaN;
      }
      if (!isNaN(line2)) doChange(line2, 0, "removed", name, ci);
    }
  }

  function onPopupChange(e) {
    var t = e.target;
    var input = t && t.closest ? t.closest(".cart__popup-qty--input") : null;
    if (!input) return;
    e.stopPropagation();
    var line = parseInt(input.getAttribute("data-line"), 10);
    var val = parseInt(input.value, 10);
    if (isNaN(val) || val < 1) val = 1;
    doChange(line, val, "change");
  }

  function onCaptureClick(e) {
    var t = e.target;
    var btn = t && t.closest ? t.closest(".product-form__cart-submit") : null;
    if (!btn) return;
    if (btn.disabled || btn.getAttribute("aria-disabled") === "true") return;
    var form = btn.closest("form");
    if (!form) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    doAdd(form);
  }

  function onCaptureSubmit(e) {
    var f = e.target;
    if (f && f.querySelector && f.querySelector(".product-form__cart-submit")) {
      e.preventDefault();
      e.stopImmediatePropagation();
      doAdd(f);
    }
  }

  function openCart(mode) {
    if (BUSY) return;
    BUSY = true;
    MODE = mode || "popup";
    renderPopup(null, null)
      .then(function (totalCents) { refreshProductWidget(totalCents); })
      .catch(function () {})
      .then(function () { BUSY = false; });
  }

  function onCaptureCartClick(e) {
    if (!DRAWER_ON) return;
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest(".site-header__cart, .site-header__cart-icon")) return;
    if (t.closest(".block_cart_canvas") || t.closest("." + WRAP_CLASS)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openCart("drawer");
  }

  var SYNC_SEL_OTHER = ".cart__mini-qty--minus,.cart__mini-qty--plus,.remove-from-cart," +
                       ".cart__popup-qty--minus,.cart__popup-qty--plus,.cart__popup-remove";
  var SYNC_SEL_PAGE = ".js-qty__adjust,.cart__qty-input";

  function money(cents) {
    return "$" + (cents / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function syncCartPage(known) {
    if (!document.querySelector(".cart__qty-input")) return;
    var read = known && known.items
      ? Promise.resolve(known)
      : fetch("/cart.js", { headers: { "X-Requested-With": "XMLHttpRequest" } })
          .then(function (r) { return r.json(); });
    read
      .then(function (cart) {
        var rows = document.querySelectorAll(".cart__qty-input");
        if (rows.length !== cart.items.length) { window.location.reload(); return; }

        var totals = document.querySelectorAll(".product-subtotal");
        for (var i = 0; i < rows.length; i++) {
          var item = cart.items[i];
          if (!item) continue;
          if (String(rows[i].value) !== String(item.quantity)) rows[i].value = item.quantity;
          if (totals[i]) totals[i].textContent = money(item.line_price);
        }

        var sub = document.querySelector(".cart__subtotal");
        if (sub) sub.textContent = money(cart.total_price);

        var head = document.querySelector(".cart__heading span");
        if (head) head.textContent = cart.item_count === 1 ? "1 item in your cart" : cart.item_count + " items in your cart";

        updateCartCount(cart.item_count);

        var fsc = document.querySelector(".rp-fsc.ccc-cart-fsc");
        if (fsc) {
          fsc.setAttribute("data-fsc-cart-total", cart.total_price);
          if (window.CCC_FSC && window.CCC_FSC.updateProgress) window.CCC_FSC.updateProgress(fsc);
        }
      })
      .catch(function () {  });
  }

  function onCartPageMutation(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest(SYNC_SEL_OTHER) && !t.closest(SYNC_SEL_PAGE)) return;
    setTimeout(syncCartPage, 900);
  }

  window.CCC_CART_SET_COUNT = updateCartCount;

  window.CCC_CART_OPEN = openCart;

  window.CCC_CART_REFRESH_FSC = refreshProductWidget;

  function init() {
    if (bound) return;
    bound = true;
    window.addEventListener("click", onCaptureCartClick, true);
    window.addEventListener("click", onCaptureClick, true);
    window.addEventListener("submit", onCaptureSubmit, true);
    document.addEventListener("keydown", function (e) {
      if ((e.key === "Escape" || e.keyCode === 27) && isOpen()) closePopup();
    });
    document.addEventListener("keydown", trapTab, true);
    if (document.body && document.body.classList.contains("template-cart")) {
      document.addEventListener("click", onCartPageMutation);
      document.addEventListener("change", onCartPageMutation);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
(function () {
  var lastRead = 0;
  var DEBOUNCE_MS = 350;
  var TRASH_SVG =
    '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" ' +
    'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/></svg>';
  var NOTE_MS     = 4000;
  var UNDO_MS     = 4200;

  var timers = {};
  var BTN_SEL = ".add-to-cart-btn, .rp-stickybuy-btn, .fp-stickybuy-btn";

  function holders() {
    var out = [], forms = document.querySelectorAll("form.variants");
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      var vid = f.querySelector(".current_variant_id");
      var holder = f.querySelector(".item-product__btn-add");
      if (!vid || !vid.value || !holder) continue;
      out.push({ vid: String(vid.value), holder: holder,
                 btn: holder.querySelector(BTN_SEL) });
    }
    var slot = document.querySelector(".rp-stickybuy .rp-stickybuy-act");
    var pvid = document.querySelector("#RegularProductForm input[name='id']");
    if (slot && pvid && pvid.value) {
      out.push({ vid: String(pvid.value), holder: slot,
                 btn: slot.querySelector(BTN_SEL) });
    }
    var fslot = document.querySelector(".fp-stickybuy .fp-stickybuy-act");
    var fvid = document.querySelector("#FreightProductForm input[name='id']");
    if (fslot && fvid && fvid.value) {
      out.push({ vid: String(fvid.value), holder: fslot,
                 btn: fslot.querySelector(BTN_SEL) });
    }
    return out;
  }

  function noteEl(holder, ms) {
    var box = holder.querySelector(".ccc-cq-wrap") || holder;
    var n = box.querySelector(".ccc-cq-note");
    if (!n) {
      n = document.createElement("div");
      n.className = "ccc-cq-note";
      n.setAttribute("role", "status");
      box.appendChild(n);
    }
    clearTimeout(n.cccTimer);
    n.cccTimer = setTimeout(function () { if (n.parentNode) n.parentNode.removeChild(n); }, ms || NOTE_MS);
    return n;
  }

  function note(holder, text) {
    noteEl(holder, NOTE_MS).textContent = text;
  }

  function drawRemoved(card, hadQty) {
    var wrap = card.holder.querySelector(".ccc-cq-wrap");
    if (!wrap) return;
    var box = wrap.querySelector(".ccc-cq");
    if (!box) return;
    wrap.dataset.removed = "1";
    wrap.dataset.had = hadQty || 1;
    box.className = "ccc-cq ccc-cq--removed";
    box.style.setProperty("--ccc-undo", UNDO_MS + "ms");
    box.innerHTML = '<span class="ccc-cq-removed-lbl">Removed</span>' +
                    '<button type="button" class="ccc-cq-undo">Undo</button>';
    clearTimeout(wrap.cccRestore);
    wrap.cccRestore = setTimeout(function () { undraw(card); }, UNDO_MS);
  }

  function undoRemoval(wrap) {
    var holder = wrap.parentNode;
    var card = { vid: wrap.dataset.vid, holder: holder,
                 btn: holder.querySelector(BTN_SEL) };
    var qty = parseInt(wrap.dataset.had, 10) || 1;
    clearTimeout(wrap.cccRestore);
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify({ id: card.vid, quantity: qty })
    }).then(function () {
      delete wrap.dataset.removed;
      var box = wrap.querySelector(".ccc-cq");
      if (box && box.parentNode) box.parentNode.removeChild(box);
      draw(card, qty);
      lastRead = 0;
      refresh();
    }).catch(function () { note(holder, "Could not put it back. Try adding it again."); });
  }

  function leftHTML(qty) {
    return qty <= 1
      ? '<button type="button" class="ccc-cq-trash" aria-label="Remove from cart">' + TRASH_SVG + "</button>"
      : '<button type="button" class="ccc-cq-minus" aria-label="Decrease quantity">−</button>';
  }

  function update(card, qty) {
    var wrap = card.holder.querySelector(".ccc-cq-wrap");
    var box = wrap && wrap.querySelector(".ccc-cq");
    if (!box) return false;
    wrap.dataset.qty = qty;
    var n = box.querySelector(".ccc-cq-n");
    var left = box.firstElementChild;
    if (!n || !left) return false;
    n.textContent = qty;
    var wantsTrash = qty <= 1;
    if (left && left.classList.contains("ccc-cq-trash") !== wantsTrash) {
      var tmp = document.createElement("div");
      tmp.innerHTML = leftHTML(qty);
      box.replaceChild(tmp.firstChild, left);
    }
    return true;
  }

  function draw(card, qty) {
    var wrap = card.holder.querySelector(".ccc-cq-wrap");
    if (wrap && wrap.querySelector(".ccc-cq") && update(card, qty)) return;
    if (!wrap) {
      wrap = document.createElement("div");
      wrap.className = "ccc-cq-wrap";
      card.holder.insertBefore(wrap, card.holder.firstChild);
    }
    var soldOut = !!(card.btn && card.btn.disabled);
    wrap.dataset.qty = qty;
    wrap.dataset.vid = card.vid;
    wrap.innerHTML =
      '<div class="ccc-cq">' + leftHTML(qty) +
        '<span class="ccc-cq-n" role="status" aria-live="polite">' + qty + "</span>" +
        '<button type="button" class="ccc-cq-plus" aria-label="Increase quantity"' +
          (soldOut ? " disabled" : "") + ">+</button>" +
      "</div>";
    if (card.btn) card.btn.style.setProperty("display", "none", "important");
  }

  function undraw(card) {
    var wrap = card.holder.querySelector(".ccc-cq-wrap");
    if (wrap) { clearTimeout(wrap.cccRestore); wrap.parentNode.removeChild(wrap); }
    if (card.btn) { card.btn.cccAddedHand = null; card.btn.style.removeProperty("display"); }
  }

  function drawSoon(card, qty) {
    var btn = card.btn;
    if (!btn || !btn.classList.contains("ccc-added")) { draw(card, qty); return; }
    btn.cccAddedHand = function () { handOver(card, qty); };
  }

  function handOver(card, qty) {
    var btn = card.btn;
    var lbl = btn && btn.querySelector(".ccc-added-lbl");
    draw(card, qty);
    var wrap = card.holder.querySelector(".ccc-cq-wrap");
    if (!lbl || !wrap) return;
    wrap.appendChild(lbl);
    void lbl.offsetWidth;
    lbl.classList.add("ccc-added-going");
    setTimeout(function () { if (lbl.parentNode) lbl.parentNode.removeChild(lbl); }, 360);
  }

  function paint(cart) {
    syncBadge(cart);
    var map = {}, i;
    for (i = 0; i < cart.items.length; i++) map[String(cart.items[i].variant_id)] = cart.items[i].quantity;
    var cards = holders();
    for (i = 0; i < cards.length; i++) {
      var w = cards[i].holder.querySelector(".ccc-cq-wrap");
      if (w && w.dataset.removed === "1") continue;
      if (map[cards[i].vid]) drawSoon(cards[i], map[cards[i].vid]);
      else undraw(cards[i]);
    }
  }

  function refresh() {
    if (!holders().length) return;
    var now = Date.now();
    if (now - lastRead < 250) return;
    lastRead = now;
    fetch("/cart.js", { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { paint(cart); watchCount(); })
      .catch(function () {  });
  }

  function commit(vid, qty, holder) {
    clearTimeout(timers[vid]);
    timers[vid] = setTimeout(function () {
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: JSON.stringify({ id: vid, quantity: qty })
      }).then(function (r) {
        if (r.ok) return r.json();
        return r.json().catch(function () { return {}; }).then(function (err) {
          note(holder, err.message || err.description || "That is all we have in stock.");
          return null;
        });
      }).then(function (cart) {
        if (cart && cart.items) {
          paint(cart);
          syncBadge(cart);
          if (typeof window.CCC_CART_REFRESH_FSC === "function") window.CCC_CART_REFRESH_FSC(cart.total_price);
        }
        else refresh();
      }).catch(refresh);
    }, DEBOUNCE_MS);
  }

  function syncBadge(cart) {
    if (typeof window.CCC_CART_SET_COUNT === "function") window.CCC_CART_SET_COUNT(cart.item_count);
  }

  document.addEventListener("click", function (e) {
    var plus  = e.target.closest ? e.target.closest(".ccc-cq-plus")  : null;
    var minus = e.target.closest ? e.target.closest(".ccc-cq-minus") : null;
    var trash = e.target.closest ? e.target.closest(".ccc-cq-trash") : null;
    var undo  = e.target.closest ? e.target.closest(".ccc-cq-undo")  : null;
    if (undo) { e.preventDefault(); e.stopPropagation(); undoRemoval(undo.closest(".ccc-cq-wrap")); return; }
    if (!plus && !minus && !trash) return;
    e.preventDefault();
    e.stopPropagation();
    var wrap = (plus || minus || trash).closest(".ccc-cq-wrap");
    if (wrap.dataset.removed === "1") return;
    var holder = wrap.parentNode;
    var next = trash ? 0 : parseInt(wrap.dataset.qty, 10) + (plus ? 1 : -1);
    if (next < 1 && !trash) next = 1;
    var card = { vid: wrap.dataset.vid, holder: holder,
                 btn: holder.querySelector(BTN_SEL) };
    var had = parseInt(wrap.dataset.qty, 10);
    if (next === 0) drawRemoved(card, had); else update(card, next);
    commit(card.vid, next, holder);
  }, true);

  var addedWatch = new MutationObserver(function (recs) {
    for (var i = 0; i < recs.length; i++) {
      var el = recs[i].target;
      if (el && el.classList && el.classList.contains("ccc-added")) { refresh(); return; }
    }
  });
  addedWatch.observe(document.documentElement,
    { subtree: true, attributes: true, attributeFilter: ["class"] });

  var countWatch = new MutationObserver(function () { refresh(); });
  function watchCount() {
    countWatch.disconnect();
    var nodes = document.querySelectorAll(".cart-count, .site-header__cart-count, #CartCount");
    for (var i = 0; i < nodes.length; i++) {
      countWatch.observe(nodes[i], { childList: true, characterData: true, subtree: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { refresh(); watchCount(); });
  } else { refresh(); watchCount(); }
})();
